import React, { useEffect, useState } from "react";
import "./styles.css";
import moment from "moment";
import { ReactComponent as CloseIco } from "common/assets/svg/wrong.svg";
import { useDispatch, useSelector } from "react-redux";
import { setEventOrderSlotTime, setPickupTime } from "common/features/cart/cartActions";
import { RootState } from "common/rootReducer";



interface DateOption {
  date: string;
}

interface EventDatePopupInterface{
    eventDate:string;
    onClose?:any;
}

interface TimeOption {
    id:number,
    eventStartDate: string|null,
    startTime: string,
    endTime: string,
    orderPerSlot: number,
    currentOrderPerSlot: number
}

const EventDatePopup = (props:EventDatePopupInterface) => {
  const {onClose, eventDate } = props;
  const dispatch = useDispatch();

  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [selectedTime, setSelectedTime] = useState<TimeOption | null>(null);
  const [selectedTimeId, setSelectedTimeId] = useState<string | number | null>(null);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState<string>('');



  const [eventDates, setEventDates] = useState<Array<DateOption>>([]);
  const [eventTimeSlot, setEventTimeSlot] = useState<Array<TimeOption>>([]);


  const cart = useSelector((state: RootState) => state.cart.cart);
  const isEventDate = useSelector((state: RootState) => state.cart.isEventDate);
  const eventSlot = useSelector((state: RootState) => state.restaurant.eventSlot);

  useEffect(() => {    
    if (eventDate) {
       !isEventDate && setSelectedDate(eventSlot[0].startDate);
       isEventDate &&  cart &&  setSelectedDate(cart?.pickUpDate);
    }
  }, [eventDate]);

  useEffect(() => {
    
    if(eventSlot){
      const currentDaySlot = eventSlot.find(slot => slot.startDate == selectedDate);  
      setEventDates(eventSlot);
     // setSelectedDate(currentDaySlot?.startDate);
      setEventTimeSlot(currentDaySlot?.timeSlots)
    }
  }, [eventSlot,eventDate,selectedDate])
  

  useEffect(() => {
    if(isEventDate && eventTimeSlot){
        const defaultSlot = eventTimeSlot.find(slot => slot.currentOrderPerSlot !== slot.orderPerSlot && slot.startTime == cart.pickUpTime);
        defaultSlot && setSelectedTime(defaultSlot)
        defaultSlot && setSelectedTimeId(defaultSlot?.startTime)
    }
  }, [isEventDate,eventTimeSlot])
  
  const handleContinue =()=>{
     selectedTimeSlot && dispatch(setEventOrderSlotTime(selectedTimeSlot));
    selectedTime && selectedDate && dispatch(setPickupTime(selectedTime.startTime, selectedDate, false,true));
    onClose();
  }

  const handleCancel =()=>{
    //selectedTime && dispatch(setPickupTime(selectedTime.startTime, moment(eventDate, 'DDMMYYYY').format('YYYY-MM-DD'), false,true));
    onClose();
  }

  return (
    <div className="popup-overlayZaEV">
        <div className="datetime-picker">
        <div className="modal-header" >
            <div/>
            <span className="model-header-text">Select Date & time Slot</span>
            <button className="close-button" onClick={handleCancel}><CloseIco/></button>
        </div>
        
        <div className="date-section">
            <span className="model-header-text1">Pick a Date</span>
              <div className="date-options">
              {eventDates.map((d:any, index) => (
                  <div
                  key={index}
                  className={`date-option ${selectedDate === d.startDate ? "active" : ""}`}
                  onClick={() => {setSelectedDate(d.startDate);setSelectedTime(null);}}
                  >
                    {console.log(selectedDate === d.startDate)}
                      <span className="d1txt">{moment(d.startDate, 'YYYY-MM-DD').format('ddd')}</span>
                      <span className="d2txt">{moment(d.startDate, 'YYYY-MM-DD').format('DD')}</span>
                      <span className="d3txt">{moment(d.startDate, 'YYYY-MM-DD').format('MMM')}</span>
                  </div>
              ))}
              </div>
            </div>
        
        <div className="time-section">
        <span className="model-header-text1">Pick a Time</span>
        <div className="scrollable-divEDP ">
            <div className="time-options2">
            {eventTimeSlot?.map((time:TimeOption, index) => (
                <div
                key={index}
                className={`time-option ${time.currentOrderPerSlot === time.orderPerSlot? "disabled":""} ${selectedTime?.startTime === time?.startTime ? "active" : ""}`}
                onClick={() => {
                  setSelectedTime(time);
                  setSelectedTimeSlot(moment(time.startTime, 'HH:mm:ss').format('hh:mm A')+" - "+moment(time.endTime, 'HH:mm:ss').format('hh:mm A'))
                }}
                >
                {moment(time.startTime, 'HH:mm:ss').format('hh:mm A')} - {moment(time.endTime, 'HH:mm:ss').format('hh:mm A')}
                </div>
            ))}
            </div>
        </div>
        </div>

        <div className="action-buttons">
            <div className="cancel-button" onClick={handleCancel}>Cancel</div>
            <div className={`continue-button ${(!selectedDate || !selectedTime) ? "disabledBtn":""}`} onClick={handleContinue}>
            Continue
            </div>
        </div>
        </div>
    </div>
  );
};

export default EventDatePopup;
